import client from '@/api/client.js'
import store from "@/store";

export default {
    methods: {
        async getRunningTasks() {
            var meta = {
                clientApiMethod: 'getRunningTasks',
                input: {  },
            }
            var response = await client()
                .get(store.state.apiRouteRoot + "../task", { meta: meta });
            return response.data;
        },
        async getPlans() {
            var meta = {
                clientApiMethod: 'getPlans',
                input: {  },
            }
            var response = await client()
                .get(store.state.apiRouteRoot + "../task/plans", { meta: meta });
            return response.data;
        },
        async disablePlan(name) {
            var meta = {
                clientApiMethod: 'disablePlan',
                input: { name },
            }
            var response = await client()
                .post(store.state.apiRouteRoot + "../task/disable/" + name, { meta: meta });
            return response.data;
        },
        async activatePlan(name) {
            var meta = {
                clientApiMethod: 'activatePlan',
                input: { name },
            }
            var response = await client()
                .post(store.state.apiRouteRoot + "../task/activate/" + name, { meta: meta });
            return response.data;
        },
        async taskCancelWait(taskId) {
            var meta = {
                clientApiMethod: 'taskCancelWait',
                input: { taskId: taskId },
            }
            var response = await client()
                .post(store.state.apiRouteRoot + "../task/cancelWait/" + taskId, { meta: meta });
            return response.data;
        }
    }
}